import { getPSProjectInfo, savePsProject } from '@ps/api/project'
import gameIframe from '@ps/bridge/iframe/iframe'
import { VpBaseMethods } from '@ps/bridge/qc/vp/config'
import { getCurrentActionName } from '@ps/views/workbench/quick-tool-bar/event-action-manager/tools'
import { getDescendants } from '@ps/bridge/qc/node/utils'
import { isRigidBody } from '@ps/workbench/undo-redo/module/box2d'
import { isIvPage } from '@ps/router/config'
import * as editorScript from '@ps/bridge/qc/scripts/editor'

function getInitState() {
  return {
    info: {},
    // 是否是使用场景规范制作非标准包（不是从 ps 制作的从 0 到 1 的素材包，且素材包符合场景规范）
    isNormMaterialWithSceneSpec: false,
    // 标准包：true 指使用 ps 从 0 到 1 制作的素材包，false 适配的包
    isNormMaterial: true,
    // 默认为 2，即 2d 素材，如果场景节点数量 < 2, 则为 1： EC， 如果场景节点数量 > 2, 再判断是否含有视频节点，含有视频节点则为 4： 交互视频，其他均为 2： 2D 素材
    materialType: 2,
    bind_demand: {
      id: 0, // 需求ID
      status: 0, // 需求状态
      submit_status: 0, // 最后一次提测状态
    },
    isBlankProject: true, // 是否空白模板创建的项目
    enableRigidBody: false, // 是否运行开启刚体参数
    isUserTemplateProject: false, // 外部用户自己创建的模版
    materialEvent: '', // 事件检测的事件
  }
}

export default {
  namespaced: true,

  state: getInitState(),

  mutations: {
    updateBindDemand(state, data) {
      Object.assign(state.bind_demand, data)
    },
    updateInfo(state, value) {
      state.info = value
      // is_native= 1 表示原生PS制作，2 为适配的。
      state.isNormMaterial = state.info.is_native === 1
      // spec_ver === 2 是使用新规范制作的非标准包（从 ps 从 0 到 1 制作出来的包 spec_ver 也等于 2）
      state.isNormMaterialWithSceneSpec =
        state.info.spec_ver === 2 && !state.isNormMaterial
      // 正式环境创建的空白项目template_id === 1,预发布环境创建的空白项目template_id === 2,PT模版转自由编辑的项目为其他值
      state.isBlankProject =
        state.info.template_id === 1 || state.info.template_id === 2
      // 外部用户自己创建的模版
      state.isUserTemplateProject =
        state.info.template_id > 2 && state.info.source === 'ps'
      // pt模版创建的项目是否支持刚体参数编辑
      state.enableRigidBody = state.info.enable_rigid_body === 1
      if (value.bind_demand) {
        Object.assign(state.bind_demand, value.bind_demand)
      }
      state.materialEvent = state.info.material_event
    },

    updateProjectInfoActions(state, value) {
      const actions = state.info.actions || {}
      actions[value.key] = value.val
      state.info.actions = actions
    },

    reset(state) {
      Object.assign(state, getInitState())
    },

    updateMaterialType(state, value) {
      state.materialType = value
    },

    updateEnableWxgame(state, value) {
      state.info.enable_wxgame = value
    },
  },

  actions: {
    async getProjectInfo({ commit }, { id }) {
      const res = await getPSProjectInfo({ id: Number(id) })
      if (res.code === 0) {
        commit('updateInfo', res.data)
        commit('updateMaterialType', res.data.material_type)
        return res.data
      }
      return null
    },

    async saveProjectThumbnail({ rootState, state, commit }, { thumbnail }) {
      const res = await savePsProject({
        id: rootState.workspace.pid,
        thumbnail,
      })
      if (res.code === 0) {
        commit('updateInfo', {
          ...state.info,
          thumbnail,
        })
        return res.data
      }
      return null
    },

    async saveProjectMaterialInfo(
      { rootState, state, commit, dispatch },
      { materialType },
    ) {
      const postParams = {
        id: rootState.workspace.pid,
        actions: JSON.stringify(getCurrentActionName()),
        material_event: state.isNormMaterial
          ? await dispatch('updateMaterialEvent')
          : [VpBaseMethods.vpInstall, VpBaseMethods.vpGameEnd].join(),
      }
      state.materialEvent = postParams.material_event
      // 用户试玩步骤选择决定素材类型
      if (materialType) {
        postParams.material_type = materialType
      }
      const res = await savePsProject(postParams)
      if (res.code === 0) {
        console.log(res.data)
        return res.data
      }
      return null
    },
    // 非适配素材，前端解析产生 material_event
    async updateMaterialEvent({ state, commit }) {
      let materialEvent = []
      // 现在只检测这两个事件
      let detectEvent = [VpBaseMethods.vpGameEnd, VpBaseMethods.vpInstall]
      if (isIvPage()) {
        // 互动视频项目会自动发送gameEnd，不用检测
        materialEvent = [VpBaseMethods.vpGameEnd]
        detectEvent = [VpBaseMethods.vpInstall]
        const ped = editorScript.getScript(gameIframe.gamePlay)
        // 互动视频里如果设置了自动install，就不用去事件表里面检测了
        if (
          ped.$data.autoInstallWhenGameEnd ||
          ped.$data.clickTimeToInstall > 0
        ) {
          materialEvent.push(VpBaseMethods.vpInstall)
          detectEvent = []
        }
      }
      function isEmpty(obj) {
        return Object.keys(obj).length === 0
      }

      function setMaterialEvent(data) {
        if (data.vpAst && !isEmpty(data.vpAst)) {
          for (const key in data.vpAst) {
            // 遍历所有响应事件
            if (data.vpAst[key].action && data.vpAst[key].action.length) {
              // 获取响应事件中命中的事件
              const targetAction = data.vpAst[key].action.filter(function (
                item,
              ) {
                return detectEvent.includes(item.method)
              })
              if (targetAction && targetAction.length) {
                targetAction.forEach(function (item) {
                  if (materialEvent.includes(item.method)) {
                    return
                  }
                  materialEvent.push(item.method)
                })
              }
            }
          }
        }
      }

      function loopFn(node) {
        if (node.children && node.children.length) {
          node.children.forEach(loopFn)
        }
        if (node.data) {
          setMaterialEvent(node.data)
        }
        // 如果存在结束场景，则代表有 gameEnd 事件
        if (node.SceneConfig && node.SceneConfig.isEnding) {
          if (materialEvent.includes(VpBaseMethods.vpGameEnd)) {
            return
          }
          materialEvent.push(VpBaseMethods.vpGameEnd)
        }
      }
      if (detectEvent.length > 0) {
        loopFn(gameIframe.gamePlay)
      }

      return materialEvent.join()
    },
    // 检查是否包含box2d和视频
    async checkVideoBox2d({ state, commit, rootState }) {
      const gamePlay = rootState.workspace.game.gamePlay
      const nodes = getDescendants(gamePlay)
      let hasRigidBody = false
      let hasVideo = false
      for (const i in nodes) {
        const node = nodes[i]
        if (node) {
          const ped = node.getScript('playsmart.editor.data')
          if (ped && ped.$data && ped.$data.box2d) {
            if (isRigidBody(node)) {
              hasRigidBody = true
            }
          }
          const video = node.getScript('ps.Video')
          if (video) {
            hasVideo = true
          }
        }
      }
      if (hasRigidBody || hasVideo) {
        commit('updateEnableWxgame', 2)
      } else {
        commit('updateEnableWxgame', 1)
      }

      await savePsProject({
        id: rootState.workspace.pid,
        enable_wxgame: state.info.enable_wxgame,
      })
    },
  },
}
